import {ActionContext, ActionTree, MutationTree} from 'vuex'
import sdk from '@/lib/sdk'
import {AppConfig} from '@/lib/interfaces'
import {EventBus} from '@/main'

interface AppVersion {
  version_number: number
}

export class AppConfigState {
  public appConfig!: AppConfig
  public appVersionNumber!: number
}

const state = new AppConfigState()

const mutations: MutationTree<AppConfigState> = {
  SET_CONFIG(cfState, payload: AppConfig) {
    cfState.appConfig = payload
  },
  SET_APP_VERSION(cfState, payload: AppVersion) {
    cfState.appVersionNumber = payload.version_number
  },
}

const actions: ActionTree<AppConfigState, any> = {
  init(store: ActionContext<AppConfigState, any>) {
    store.dispatch('loadAppVersion')
    store.dispatch('loadConfig')
  },
  loadConfig(store: ActionContext<AppConfigState, any>) {
    return sdk.app.config().then((response) => {
      store.commit('SET_CONFIG', response.data)
      store.dispatch('sleep')
      EventBus.$emit('configLoaded')
      return response.data
    })
  },
  loadAppVersion(store: ActionContext<AppConfigState, any>) {
    return sdk.app.version().then((response: any) => {
      store.commit('SET_APP_VERSION', response.data)
      store.dispatch('sleep')
      return response.data
    })
  },
}

export default {
  state,
  mutations,
  actions,
}
